import React from 'react';

const ModalFinish = params => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={params.width || 32}
    height={params.height || 32}
    viewBox="0 0 32 32"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill={params.color || '#00CE64'}
        fillRule="nonzero"
        d="M16 2.667c7.364 0 13.333 5.97 13.333 13.333 0 7.364-5.97 13.333-13.333 13.333-7.364 0-13.333-5.97-13.333-13.333C2.667 8.636 8.637 2.667 16 2.667zm-5.716 12.395a1.336 1.336 0 0 0-1.886.013 1.33 1.33 0 0 0 .013 1.883l4.06 3.995a1.336 1.336 0 0 0 1.809.06l9.272-8.005a1.33 1.33 0 0 0 .137-1.878 1.336 1.336 0 0 0-1.882-.136l-8.34 7.2-3.183-3.132z"
      />
    </g>
  </svg>
);

export default ModalFinish;
